export const FETCH_PLATFORM_DETAILS = 'platformDetails/FETCH_PLATFORM_DETAILS'
